export enum LegalDocumentTypeEnum {
    CGU = 'cgu',
    PRIVACY = 'privacy',
    CGV = 'cgv',
}
